<template>
  <div>
    <!-- BREADCRUMB -->
    <DiagnosticBuilderBreadCrumb
      :parents="parents"
      :step="node"
      @update-parents="$emit('update-parents', $event)"
      @focus-node="$emit('focus-node', $event)"
    />

    <!-- EDITOR CARD -->
    <DiagnosticBuilderEditorCard
      :content="content"
      :editable="editable"
      :appLanguage="appLanguage"
      @update-content="$emit('update-content', $event)"
      @delayed-update-content="$emit('delayed-update-content', $event)"
      @unlink-node="$emit('unlink-node', $event)"
      @flush-update-content="$emit('flush-update-content')"
      @generate-summary="$emit('generate-summary')"
    />

    <!-- CHILDREN -->
    <DiagnosticBuilderChildren
      :node="node"
      :content="content"
      :root-id="rootId"
      :editable="editable"
      :options="options"
      @focus-node="$emit('focus-node', $event)"
      @update-content="$emit('update-content', $event)"
      @update-children-order="$emit('update-children-order', $event)"
      @add-child="$emit('add-child', $event)"
      @update-node="$emit('update-node', $event)"
      @relocate-child="$emit('relocate-child', $event)"
      @delete-child="$emit('delete-child', $event)"
    />

    <!-- TRIGGER EDITOR -->
    <DiagnosticBuilderTriggerEditorCard
      v-if="!isParametric && (actionsEdited || editMessage)"
      :node-id="content.id"
      :user-permissions="content.userPermissions"
      :actions="actions"
      :trigger-action="triggerAction"
      @update-content-actions="$emit('update-content-actions', $event)"
      @delayed-update-content-actions="
        $emit('delayed-update-content-actions', $event)
      "
      @flush-update-content="$emit('flush-update-content')"
    />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import DiagnosticBuilderBreadCrumb from './DiagnosticBuilderBreadCrumb';
import DiagnosticBuilderEditorCard from './DiagnosticBuilderEditorCard';
import DiagnosticBuilderChildren from './DiagnosticBuilderChildren/DiagnosticBuilderChildren';
import DiagnosticBuilderTriggerEditorCard from './DiagnosticBuilderTriggerEditorCard';

const TRIGGER_ACTIONS_IDS = ['salesforce.caseUpdate'];

export default {
  name: 'diagnostic-builder-main',
  components: {
    DiagnosticBuilderBreadCrumb,
    DiagnosticBuilderEditorCard,
    DiagnosticBuilderChildren,
    DiagnosticBuilderTriggerEditorCard,
  },
  props: {
    node: Object,
    content: Object,
    parents: Array,
    editMessage: {
      type: Boolean,
      default: false,
    },
    rootId: String,
    editable: {
      type: Boolean,
      default: false,
    },
    options: Object,
  },
  computed: {
    actions() {
      if (!this.content.actions || !this.content.actions[0]) {
        return this.initActions();
      }
      const action = this.content.actions.find(
        (el) => !TRIGGER_ACTIONS_IDS.includes(el.id),
      );
      if (!action) {
        return this.initActions();
      }
      return action.payload;
    },
    triggerAction() {
      if (!this.content.actions && !this.content.actions.length) {
        return {};
      }
      const triggerAction = this.content.actions.find((el) =>
        TRIGGER_ACTIONS_IDS.includes(el.id),
      );
      if (!triggerAction) {
        return {};
      }
      return triggerAction;
    },
    actionsEdited() {
      const filledKeys = Object.keys(this.actions).filter(
        (key) => !['<br>', '<p></p>', ''].includes(this.actions[key]),
      );
      const hasFilledKeys = filledKeys.length > 0;
      this.$emit('actions-edited', hasFilledKeys);
      return hasFilledKeys;
    },
    ...mapGetters(['isParametric']),
    ...mapState(['appLanguage']),
  },
  methods: {
    initActions() {
      return {
        macro_id: '',
        assignee_group_id: '',
        assignee_user_id: '',
        email_cc: '',
        status: '',
        subject: '',
        message: '',
      };
    },
  },
};
</script>

<style></style>
